import { ManagerHandlerAction, UIField } from "@bonusmap/api-types";
import { DataBaseComponent } from "./data-base-component.js";
import { DataContextComponent } from "./data-context-component.js";

export class DataSlot extends DataContextComponent {
    static webComponentName: string = "data-slot";
    protected _templateId: string = ""; // No template needed
    public readonly key!: string; // Source attribute for the slot, can be set externally
    protected control!: DataBaseComponent; // Reference to the control that uses this slot

    constructor() {
        super();
        // this.style.display = "block"; // Ensure the slot is visible
        this.key = this.attributeStringOption('key', ''); // Get the source from the attribute
    }
    private _errorMessage: string = "";
    public get errorMessage(): string {
        return this._errorMessage;
    }
    public set errorMessage(value: string) {
        this.classList.toggle('has-error', value !== "");
        this.style.setProperty('--after-content', `"${value}"`);
        this._errorMessage = value;
    }
    protected onConnected(): void {
        this.setupControl(); // Setup the control based on the field
    }
    protected render(): void {
        // No template is needed for this component
    }
    get field(): UIField {
        return this.dataSource[this.key];
    }
    
    private setupControl(): void {
        const field = this.field;
        if (!field) {
            console.warn(`DataSlot: Field is not set, cannot setup control. Key: ${this.key}`);
            return;
        }
        const elementTagName = `data-${field.type}`;
        const tmpEl = document.createElement("div");
        tmpEl.innerHTML = `<${elementTagName}></${elementTagName}>`;
        const element = tmpEl.firstElementChild as DataBaseComponent;
        if (customElements.get(elementTagName) === undefined) {
            element.innerHTML = `<span>Unknown field type: ${field.type}</span>\n
         
            `;
            console.warn(`DataSlot: Custom element ${elementTagName} is not defined.`, customElements.get(elementTagName));
            // return;
        }
        
        element.field = field; // Set the field for the component
        element.value = field.value ?? null;
        this.appendChild(element);
        tmpEl.remove(); // Clean up temporary element
    }
}